import React from 'react';
import { Tabs, Button } from 'antd';
import CaracteristicasVehiculo from '../fichaVehiculo/caracteristicasVehiculo';
import Aplicaciones from './secciones/aplicaciones';
import Especificaciones from './secciones/especificaciones';
import Galeria from './secciones/galeria';
import Videos from './secciones/videos';
import VersionesYPrecios from './secciones/versionesYPrecios';
import ExperienciaClientes from './secciones/experiencia';
import './seccionesFicha.css';
import { Col, Row } from 'react-bootstrap';
import { Sticky, StickyContainer } from 'react-sticky';
import useWindowDimensions from '../../../hooks/Front/windowDimentions/useDimentions';
import { DownloadOutlined } from '@ant-design/icons';

import IconFichaEnergetica from '../../../img/ficha/icon_ficha_energetica.png';

const { TabPane } = Tabs;

const SeccionesFicha = ({ ficha }) => {

    const { width } = useWindowDimensions();

    let margen = width <= 767 ? "51px" : width <= 991 ? "190px" : "118px"

    const renderTabBar = (props, DefaultTabBar) => (
        <Sticky topOffset={-90}>
            {({ style, isSticky }) => (
                <DefaultTabBar {...props} style={{ ...style, zIndex: 2, background: 'white', height: "80px", top: isSticky ? margen : '0px' }} />
            )}
        </Sticky>
    );

    return (
        <StickyContainer >
            <Tabs defaultActiveKey="caracteristicas" centered className="tab-hyundai mb-tab-0 " renderTabBar={renderTabBar}>
                {ficha && ficha.Caracteristicas && ficha.Caracteristicas.length > 0 &&
                    <TabPane tab={<h5 className="bold-title-hyundai f-18 px-xl-4">Características</h5>} key="caracteristicas">
                        <Row className="">
                            <Col xs={12} md={10} className="mx-auto my-ficha px-4">
                                <Row >
                                    {ficha && ficha.Caracteristicas && ficha.Caracteristicas.length > 0 &&
                                        ficha.Caracteristicas.map((caracteristica, i) =>
                                            <CaracteristicasVehiculo
                                                caracteristica={caracteristica}
                                                key={i}
                                            />
                                        )
                                    }
                                    {
                                        ficha && ficha.FichaEnergetica.length > 0 && ficha.FichaEnergetica[0].Multimedia &&
                                        <Col xs={4} md={4} lg="auto" className={`mx-auto px-0 pb-4 pb-md-0 m-caracteristicas`}>
                                            <Row>
                                                <Col className="text-center mb-3">
                                                    <img
                                                        src={IconFichaEnergetica}
                                                        className="caracteristicas-img caracteristicas-img-responsive"
                                                        alt={ficha.FichaEnergetica[0].Titulo}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="px-1">
                                                    <h5
                                                        className="text-center bold-text-hyundai f-responsive-12 mb-1"
                                                        dangerouslySetInnerHTML={{ __html: ficha.FichaEnergetica[0].Titulo }}
                                                    >
                                                    </h5>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="text-center px-1">
                                                    <Button
                                                        className='btn-secundario-ficha w-100 font-btn btn-descargar-caracteristicas'
                                                        href={ficha.FichaEnergetica[0].Multimedia}
                                                        target='_blank'
                                                        style={{ borderRadius: '4px !important' }}
                                                        icon={<DownloadOutlined />}
                                                    >
                                                        Descargar
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                </Row>
                            </Col>
                            <Col
                                xs={11}
                                md={10}
                                lg={8}
                                className="mx-auto mb-5 text-center f-responsive-10 parrafo-hyundai htmlHyundai"
                                dangerouslySetInnerHTML={{ __html: ficha?.Vehiculo?.LegalCaracteristicas }}
                            >
                            </Col>
                        </Row>
                    </TabPane>
                }
                {ficha && ficha.Aplicaciones && ficha.Aplicaciones.length > 0 &&
                    <TabPane tab={<h5 className="bold-title-hyundai f-18 px-xl-4">Aplicaciones</h5>} key="aplicaciones">
                        <Aplicaciones aplicaciones={ficha.Aplicaciones} />
                        <Row>
                            <Col
                                xs={11}
                                md={10}
                                lg={8}
                                className="mx-auto mb-5 text-center f-responsive-10 parrafo-hyundai htmlHyundai"
                                dangerouslySetInnerHTML={{ __html: ficha?.Vehiculo?.Legal }}
                            >
                            </Col>
                        </Row>
                    </TabPane>
                }
                {ficha && ficha.Especificaciones && ficha.Especificaciones.length > 0 &&
                    <TabPane tab={<h5 className="bold-title-hyundai f-18 px-xl-4">Especificaciones técnicas</h5>} key="especificaciones">
                        <Especificaciones especificaciones={ficha.Especificaciones} />
                    </TabPane>
                }
                {/*  eslint-disable-next-line */}
                {ficha && ficha.Galeria && (ficha.Galeria.Exterior && ficha.Galeria.Exterior.length > 0 || ficha.Galeria.Interior && ficha.Galeria.Interior.length > 0) &&
                    <TabPane tab={<h5 className="bold-title-hyundai f-18 px-xl-4">Tour virtual y galería</h5>} key="tour">
                        <Galeria galeria={ficha.Galeria} />
                    </TabPane>
                }
                {ficha && ficha.Videos && ficha.Videos.length > 0 &&
                    <TabPane tab={<h5 className="bold-title-hyundai f-18 px-xl-4">Videos</h5>} key="videos">
                        <Videos videos={ficha.Videos} />
                    </TabPane>
                }
                {ficha && ficha.Versiones && ficha.Versiones.length > 0 &&
                    <TabPane tab={<h5 className="bold-title-hyundai f-18 px-xl-4">Versiones y precios</h5>} key="versiones">
                        <VersionesYPrecios versiones={ficha.Versiones} tipoMoneda={ficha.Vehiculo.tipoMoneda} />
                        {/* <Row>
                            <Col
                                xs={11}
                                md={10}
                                lg={8}
                                className="mx-auto mb-5 text-center f-responsive-10 parrafo-hyundai htmlHyundai"
                                dangerouslySetInnerHTML={{ __html: ficha?.Vehiculo?.Legal }}
                            >
                            </Col>
                        </Row> */}
                    </TabPane>
                }

                {/*  eslint-disable-next-line */}
                {ficha && ficha.Experiencia && (ficha.Experiencia.Fotos && ficha.Experiencia.Fotos.length > 0 || ficha.Experiencia.Videos && ficha.Experiencia.Videos.length > 0) &&
                    <TabPane tab={<h5 className="bold-title-hyundai f-18 px-xl-5">Experiencia clientes</h5>} key="experiencia">
                        <ExperienciaClientes experiencias={ficha.Experiencia} />
                    </TabPane>
                }
            </Tabs>
        </StickyContainer>
    );
}

export default SeccionesFicha;